import http from '@/http';

export default class Service {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  get(id) {
    return http.get(`${this.baseUrl}/${id}`);
  }

  getList(params) {
    return http.get(`${this.baseUrl}`, { params });
  }

  save(payload) {
    return http.post(`${this.baseUrl}`, payload);
  }

  edit(payload) {
    return http.put(`${this.baseUrl}/${payload.id}`, payload);
  }

  delete(id) {
    return http.delete(`${this.baseUrl}/${id}`);
  }
}
